import { PetContextValues } from 'contexts/pet';
import { FormattedMessage } from 'react-intl';

interface PropTypes {
  isProfileMinimal: boolean;
  petProfileText: string;
  petType: Exclude<PetContextValues, false>;
}

/**
 * Component that displays the pet profile text.
 * Used on the PetProfileCollectionSelector component.
 */
const ProfileText: React.FC<PropTypes> = ({
  isProfileMinimal,
  petProfileText,
  petType,
}) => (
  <span
    data-test="profile-text-container"
    className="mt-3 w-full grow lg:mr-5 lg:ml-3 lg:text-left"
  >
    <span
      data-test="profile-text-title"
      className="text-text-primary mb-1 block text-sm leading-4 font-black"
    >
      <FormattedMessage
        id={`cdp:pet-profile:selector:no-pet-profile:title-${isProfileMinimal ? 'minimal' : 'extended'}-profile${
          !isProfileMinimal ? '' : '-' + petType
        }`}
      />
    </span>
    <span
      data-test="profile-text-description"
      className="text-text-secondary text-sm leading-4"
    >
      {isProfileMinimal ? (
        <FormattedMessage id="cdp:pet-profile:selector:no-pet-profile:description" />
      ) : (
        petProfileText
      )}
    </span>
  </span>
);

export default ProfileText;
